import { adminUsersAPI } from 'api/admin-users';
import { AdminUserDto } from 'dto/admin-users';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  id: number;
  enabled?: boolean;
  onSuccess?: (data: AdminUserDto) => void;
};

export function useFindOneAdminUser(props: PropsType) {
  const query = useQuery({
    queryKey: [QUERY_KEY.FIND_ONE_ADMIN_USER, props.id],
    queryFn: () => adminUsersAPI.findOne(props.id),
    enabled: !!props.id || props.enabled,
    onSuccess: props.onSuccess,
  });

  return query;
}
